<script setup> 
</script>

<template> 
  <div>
    <router-view></router-view> 
  </div>
</template>

<script> 
import { loginManager } from '@/utils/loginManager.js'

export default {
  components: { 
  },
  data() {
    return { 
    }
  },
  mounted() {
    console.log('App 初始化')
    this.userLogin()
  },
  methods: {
    async userLogin() {
      if (!localStorage.getItem("loginUserToken")){
        await loginManager.show()
      } 
    }
  }
}
</script>
<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
